<div class="page404">
    <h1>404</h1>
    <h5>{{ 'COMMON.NOT_FOUND' | translate }}</h5>
    <p>
        {{ 'COMMON.NOT_FOUND_DESC' | translate }}
    </p>
</div>